import { LOGIN_MODE } from '@app/core/enums/login/login-mode.enum';
import { AddressBook } from './address-book.dto';
import { LayoutParams } from './commons/layout-params.dto';
import { ModalType } from '../enums/modal.enums';
import { TrackingDto } from './tracking-data.dto';

export class CheckoutActionRequestDto {
  action: ActionEnum;
  payload: ActionPayloadDto[];
  url?: string;
}

export class ActionRequestDto {
  action: ActionEnum;
  navigationType: NavigationTypeEnum;
  payload: ActionPayloadDto;
  url?: string;
  tracking?: TrackingDto;
}

export class SearchRequestDto {
  action: ActionEnum;
  query: string;
  payload: SearchPayloadDto;
}
export class UserRequestDto {
  action: ActionEnum;
  payload: LoginPayloadDto;
  url?: string;

  constructor(partial: Partial<UserRequestDto>) {
    Object.assign(this, partial);
  }
}

export class ActionPayloadDto {
  sku: string;
  quantity: number;
  skuQuantity: { [key: string]: number };
  pincode: number;
  addressId: number;
  addressBook: AddressBook;

  // url is needed when action is of type navigation
  url: string;
  navigationOption: string;
  selected: boolean;
  familySKUs: string[];
  skus: { sku: string; quantity: number }[];
  promoCode?: string;
  layout?: LayoutParams;
  popupName?: ModalType;

  dealerCode: string;
  email?: string;

  constructor(partial: Partial<ActionPayloadDto>) {
    Object.assign(this, partial);
  }
}
export class SearchPayloadDto extends ActionPayloadDto {
  query: string;
  searchBrowseHistory?: [];
  constructor(partial: Partial<SearchPayloadDto>) {
    super(partial);
    Object.assign(this, partial);
  }
}

export class LoginPayloadDto extends ActionPayloadDto {
  password?: string;
  otp?: number;
  loginToken?: string;
  verificationType?: LOGIN_MODE;

  constructor(partial: Partial<LoginPayloadDto>) {
    super(partial);
    Object.assign(this, partial);
  }
}

export enum ActionEnum {
  ADD_TO_CART = 'ADD_TO_CART',
  BUY_NOW = 'BUY_NOW',
  REMOVE_FROM_CART = 'REMOVE_FROM_CART',
  SELECT_ITEMS = 'SELECT_ITEMS',
  UNSELECT_ITEMS = 'UNSELECT_ITEMS',
  UPDATE_PRODUCT_QUANTITY = 'UPDATE_PRODUCT_QUANTITY',
  ADDRESS_UPDATE = 'ADDRESS_UPDATE',
  ADDRESS_SELECT = 'ADDRESS_SELECT',
  SERVICEABILITY_AT_PINCODE = 'SERVICEABILITY_AT_PINCODE',
  EDD_CHECK_PINCODE = 'EDD_CHECK_PINCODE',
  NAVIGATION_ROUTER = 'NAVIGATION_ROUTER',
  NAVIGATION = 'NAVIGATION',
  AUTOSUGGEST = 'AUTOSUGGEST',
  LOGIN = 'LOGIN',
  REGISTER = 'REGISTER',
  ADDRESS_SAVE = 'ADDRESS_SAVE',
  ADDRESS_NEW = 'ADDRESS_NEW',
  CONFIRM_ORDER_COD = 'CONFIRM_ORDER_COD',
  INIT_PAYMENT = 'INIT_PAYMENT',
  VERIFY_USER = 'VERIFY_USER',
  VERIFY_OTP = 'VERIFY_OTP',
  RESEND_OTP = 'RESEND_OTP',
  APPLY_PROMO = 'APPLY_PROMO',
  REMOVE_PROMO = 'REMOVE_PROMO',
  ADDRESS_TAB_SELECT = 'ADDRESS_TAB_SELECT',
  SHARE = 'SHARE',
  CONTINUE_WITH_OTP = 'CONTINUE_WITH_OTP',
  FORGOT_PASSWORD = 'FORGOT_PASSWORD',
  RESET_PASSWORD = 'RESET_PASSWORD',
  REGISTRATION = 'REGISTRATION',
  BUSINESS_REGISTRATION = 'BUSINESS_REGISTRATION',
  VERIFY_EMAIL_EXISTENCE = 'VERIFY_EMAIL_EXISTENCE',
  VERIFIED_EMAIL_LINK = "VERIFIED_EMAIL",
  RESEND_EMAIL_VERIFICATION_LINK = "RESEND_EMAIL_VERIFICATION",

  /**
   * BUSINESS REGISTRATION ACTIONS
   */
  VERIFY_MOBILE_NO = 'VERIFY_MOBILE_NO',
  BUSINESS_IDENTIFICATION = 'BUSINESS_IDENTIFICATION',
  EDIT_BILLING_ADDRESS = 'EDIT_BILLING_ADDRESS',
  BUSINESS_CHANGE_PHONE_NO = 'BUSINESS_CHANGE_PHONE_NO',
  BUSINESS_BILLING_ADDRESS = 'BUSINESS_BILLING_ADDRESS',
  // user page actions

  SEND_OTP = 'SEND_OTP',
  // -- my profile actions
  UPDATE_PROFILE = 'UPDATE_PROFILE',

  // -- my orders actions
  CANCEL_ORDER = 'CANCEL_ORDER',

  // -- addressbook actions
  ADDRESS_DELETE = 'ADDRESS_DELETE',

  // -- bank account action
  BANK_ACCOUNT_DELETE = 'BANK_ACCOUNT_DELETE',
  BANK_ACCOUNT_SELECT_DEFAULT = 'BANK_ACCOUNT_SELECT_DEFAULT',

  // -- manage password actions
  UPDATE_PASSWORD = 'UPDATE_PASSWORD',

  // user page actions end
  POPUP = 'POPUP',
  LOGOUT = 'LOGOUT',

  // user page actions end

  QUERY_PARAMS = 'QUERY_PARAMS',
  RETURN_REQUEST_INITIATE = 'RETURN_REQUEST_INITIATE',
  RETURN_REQUEST_CANCEL = 'RETURN_REQUEST_CANCEL',
  /*
   * Action to get Family Products data on PLP.
   */
  GET_FAMILY_PRODUCTS_DATA = 'GET_FAMILY_PRODUCTS_DATA',
  SELECT_PAYMENT = 'SELECT_PAYMENT',

  // navigate to external links
  EXTERNAL_NAVIGATION = 'EXTERNAL_NAVIGATION',
  PRODUCT_REVIEW_SAVE = 'PRODUCT_REVIEW_SAVE',
  VERIFY_GST = 'VERIFY_GST',

  /**
   * For assisted sales login to customer id.
   */
  ASSISTED_SALES_LOGIN = 'ASSISTED_SALES_LOGIN',

  VERIFY_DEALER_CODE = 'VERIFY_DEALER_CODE',

  CALL_NOW = 'CALL_NOW',

  REQUEST_A_CALLBACK = 'REQUEST_A_CALLBACK',
  QUOTE_ONLY = 'QUOTE_ONLY',
  GET_CUSTOMIZED_PRICE = 'GET_CUSTOMIZED_PRICE',
  NAVIGATE_BY_URL = 'NAVIGATE_BY_URL',

  /**
   * action to handle redirection to correct nps form while submiting rating.
   */
   SUBMIT_NPS_RATING = "SUBMIT_NPS_RATING",
  // action to save gstin from profile in address
   UPDATE_GSTIN_IN_ADDRESS = "UPDATE_GSTIN_IN_ADDRESS",

  // user quote action
  SUBMIT_USER_QUOTE = "SUBMIT_USER_QUOTE",
  POPUP_CLOSE = "POPUP_CLOSE",

   // action for ib-credit ledger
   PAY_ALL_OUTSTANDING  = "PAY_ALL_OUTSTANDING",
   PAY_INVOICE = "PAY_INVOICE",

   NPS_FEEDBACK = "NPS_FEEDBACK",

   SUBMIT_IB_CREDIT_FORM = "SUBMIT_IB_CREDIT_FORM",
   COMPLETE_IB_CREDIT_FIRST_STEP = "COMPLETE_IB_CREDIT_FIRST_STEP",
   GOTO_IB_CREDIT_FIRST_STEP = "GOTO_IB_CREDIT_FIRST_STEP",
   INTIATE_REVIEW_FROM_PDP = "INTIATE_REVIEW_FROM_PDP",

   SEARCH_AND_REDIRECT = "SEARCH_AND_REDIRECT",
}

export enum NavigationTypeEnum {
  BACK = 'BACK',
  EXTERNAL = 'EXTERNAL',
  ROUTER = 'ROUTER',
  POPUP = 'POPUP',
}
